import axios from 'axios';
import { acBilet } from './acBilet.js'

export function acSendTicket(val) {
    for (var i = 0; i < val.numereArr.length; i++) {
        var target = val.numereArr[i];
        for (var j = i - 1; j >= 0 && (val.numereArr[j] > target); j--) {
            val.numereArr[j + 1] = val.numereArr[j];
        }
        val.numereArr[j + 1] = target
    }
    return function (dispatch) {
        dispatch({ type: 'LOADING', payload: 'sendTicket' })
        axios({
            method: 'POST',
            url: '' + val.ruta + 'place_ticket?&' + val.newParam,
            data: [{
                "lottery_name": val.numeLot,
                "end_time": val.timeStart,
                "money_in": val.miza,
                "numbers": val.numereArr.toString(),
                "game_system": val.checked.toString(),
                "win_array": val.sum.toString(),
                "currency": val.currency

            }],
        }).then(function (response) {
            if ((response.data.status) && (response.data.status === 'redirect')) { dispatch({ type: 'ERROR', payload: 1 }) }

            // console.log('acSendTicket - ', response.data);
            // dispatch({ type: 'sendTicket', payload: response.data })
            if (response.data.status === 'alert') {
                dispatch({ type: 'ALERT', payload: response.data.value })
                dispatch({ type: 'POP_VIZIBIL', payload: [true, null] })
            }
            if (response.data.status === 'popup') {
                // var values = {
                //     position: val.position,
                //     mesaj: response.data.value,
                //     valid: false
                // }
                // dispatch({ type: 'VALID_TICKET', payload: values })

                dispatch(acBilet(['sendTicket', val, { ...response.data, end_time: val.timeStart }]))
            }
            if (response.data.status === 'succes') {
                dispatch(acBilet(['sendTicket', val, response.data]))
                dispatch({ type: 'DELETE_TICKET_PARIAT', payload: true })
            }
            if (response.data.status === 'error') {
                dispatch(acBilet(['sendTicket', val, response.data]))
            }
            dispatch({ type: 'LOADING', payload: false })
        }).catch(function (error) {
            dispatch({ type: 'ERROR', payload: { conErr: true } })
            dispatch({ type: 'DEFAULT_VAL', payload: '' })
            console.log('acSendTicket - error - ', error);
        });
    }
}

